import React, { useState } from 'react'
import { Grid, useMediaQuery } from '@material-ui/core'
import "./digital-vault-categories-administration-new-category.css"
import { InputHLPure, TextAreaHLPure, ButtonHLPure } from '../../pures'
import { useTranslation } from 'react-i18next'

const DigitalVaultCategoriesAdministrationNewSubcategory =
    ({
        selectedUser,
        setShowDetails,
        selectedValueFilter,
        categories,
        createSubcategory,
        routes
    }) => {
        const { t } = useTranslation()

        const selectedFilterText = categories.find(item => item.company.id === selectedValueFilter).company.companyName
        const [showError, setShowError] = useState(false)

        const [categoryData, setCategoryData] = useState({ name: "", notes: "" })

        const validateData = () => {
            if (!categoryData.name) return setShowError(true), setTimeout(() => { setShowError(false) }, 2000)
            createSubcategory(categoryData.name, categoryData.minimunVisualization, selectedUser.companyId, categoryData.notes, routes, selectedUser.categoryId ?? selectedUser.id)
        }

        const isMobile = useMediaQuery("(max-width:560px)")

        return (
            <>
                <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className="digitalVaultCategoriesAdministrationNewCategory-wrapper"
                >
                    <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        className='digitalVaultCategoriesAdministrationNewCategory-paddingElements'
                    >
                        <span>
                            {t("digitalVaultCategoriesAdministration.subcategories.addSubcat.seeDetailsSubcategory")} <b>{selectedFilterText}</b>
                        </span>
                    </Grid>
                    <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        className="digitalVaultCategoriesAdministrationNewCategory-paddingElements"
                    >
                        <InputHLPure
                            labelInput={t("digitalVaultCategoriesAdministration.subcategories.grid.titleHeader1")}
                            typeInput={"text"}
                            inputActive
                            valueInput={categoryData.name}
                            handleChangeInput={(e) => setCategoryData({ ...categoryData, name: e.target.value })}
                            informationIcon
                            tooltipShow
                            positionTooltip={isMobile ? "top" : "right"}
                            titleTooltip={t("digitalVaultCategoriesAdministration.subcategories.grid.titleHeader1")}
                            descriptionTooltip={t("digitalVaultCategoriesAdministration.subcategories.addSubcat.enterNameCatCustom")}
                        />
                        {showError && <div>Ingresa un nombre para la categoría</div>}
                    </Grid>
                    <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        className="digitalVaultCategoriesAdministrationNewCategory-paddingElements"
                    >
                        <TextAreaHLPure
                            labelTextArea={t("digitalVaultCategoriesAdministration.subcategories.details.notes")}
                            handleChangeTextArea={(e) => setCategoryData({ ...categoryData, notes: e.target.value })}
                            valueTextData={categoryData.notes}
                        />
                    </Grid>
                    <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        className="digitalVaultCategoriesAdministrationNewCategory-container-btn"
                    >
                        <div className="digitalVaultCategoriesAdministrationNewCategory-btn-cancel">
                            <ButtonHLPure
                                nameBtn={t("button.cancel")}
                                onClickBtn={() => setShowDetails(false)}
                            />
                        </div>

                        <ButtonHLPure
                            nameBtn={t("button.save")}
                            primary
                            onClickBtn={() => validateData()}
                        />
                    </Grid>
                </Grid>

            </>

        );
    }

export default DigitalVaultCategoriesAdministrationNewSubcategory